import request from '../../../helpers/request';

const deleteFlatAccount = async (bindId) => {
  return await request.delete(
    `/HousingStock/account/${bindId}`,
    {},
    'При удалении лицевого счета произошла ошибка',
    { result: 'Error' }
  );
};

export default deleteFlatAccount;
